import { Button } from '@material-ui/core'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Field } from 'redux-form'

import { renderColorPickerField, renderTextField } from '../../Forms/fieldRenderers'
import { EntityAutocomplete } from '../../Forms/SharedComponents/containers'

export class OperacionesModificacionLlenadoSiloDialogView extends Component {
  render () {
    const {
      silo, isNewEtiqueta, setEtiquetaAsNew, etiquetaSeleccionada
    } = this.props
    return (
      <div>
        <Row>
          <Col md={12}>
            <h2>Modificar llenado de {silo.nombreCorto}</h2>
          </Col>
        </Row>
        <Row>
          <Col md={8}>
            {isNewEtiqueta && <Field
              name='newEtiqueta'
              label='Etiqueta'
              type='text'
              component={renderTextField}
              placeholder='Etiqueta'
            />}
            {!isNewEtiqueta && <EntityAutocomplete
              name='etiqueta'
              label='Etiqueta'
              entity='etiqueta_silo'
              placeholder='Etiqueta'
              onSelected={etiquetaSeleccionada}
            />}

          </Col>
          <Col md={4}>
            {!isNewEtiqueta && <Button onClick={() => setEtiquetaAsNew(true)}>
              Nueva
              Etiqueta
            </Button>}
            {isNewEtiqueta && <Button onClick={() => setEtiquetaAsNew(false)}>
              Reusar
              Etiqueta
            </Button>}
          </Col>
        </Row>
        {isNewEtiqueta && <Row>
          <Col md={12}>
            <Field
              name='color'
              label='Color'
              type='text'
              component={renderColorPickerField}
              placeholder=''
              initColor={silo.color.toLowerCase()}
            />
          </Col>
        </Row>}
      </div>
    )
  }
}
